import React from 'react';
import './ProgressLoader.css';

const ProgressLoader = () => {

    return (
        <div className='progress-loader'>
            <div className="loader"></div>
        </div>
    )
}

export default ProgressLoader